import React, {useContext, useEffect, useRef} from 'react';
import {useMap} from "react-leaflet";
import L from "leaflet";

const CCMap = ({flight,children}) => {
    const map = useMap()

    const [initialized,setInitialised] = React.useState()

    useEffect(() => {
        const taskLayer = new L.FeatureGroup()
        taskLayer.addTo(map)

        map.ccmap = {
            taskLayer: taskLayer,
        }

        setInitialised(true)
    }, []);

    return (
        <>
            {
                initialized && map && map.ccmap &&
                children
            }
        </>
    )

}

export default CCMap